import { ProSidebarProvider } from "react-pro-sidebar";

export default function ProSidebar({ children }){
    return <ProSidebarProvider>{children}</ProSidebarProvider>;
}
